/* ---------- src/app/store/index.ts --------------- */
import { ActionReducerMap, ActionReducer, Action } from '@ngrx/store';
import * as fromUser from './user';

import { asistenciaReducer } from '@app/pages/asistencias/store/asistencia.reducer';
import { AsistenciaState, AsistenciaActions } from '@app/pages/asistencias/store/asistencia.actions';
import { AsistenciaEffects } from '@app/pages/asistencias/store/asistencia.effects';

/* ---------- STATE ROOT --------------------------- */
export interface State {
  user: fromUser.UserState;
  asistencia: AsistenciaState;
}

/* ---------- UNION GLOBAL DE ACCIONES ------------- */
export type AppActions = Action | AsistenciaActions;

/* ---------- REDUCERS ----------------------------- */
export const reducers: ActionReducerMap<State, AppActions> = {
  user:         fromUser.reducer            as ActionReducer<fromUser.UserState,         AppActions>,
  asistencia:   asistenciaReducer           as ActionReducer<AsistenciaState,            AppActions>, // 👈 CAST
};

/* ---------- EFFECTS ------------------------------ */
export const effects = [
  fromUser.UserEffects,
  AsistenciaEffects,
];

/* ---------- SELECTORS ---------------------------- */
export const getAsistenciaState = (state: State) => state.asistencia;
export const getUserState       = (state: State) => state.user;
